<!-- Main -->
<div class="layout-1-auto" *ngIf="!oeSummary.isLoading">
	<div class="content grid-1-auto md3-surface" >
		<div class="content">
			<div class="app-pancake" *ngIf="!Data.defaultOE">
				<div class="app-pancake-child md3-card-on-surface" style="min-height: unset; max-height: unset;">
					<div class="content app-pancake" style="min-height: unset; max-height: unset;">
						<div class="app-pancake-child-small" style="min-height: unset; max-height: unset;">
							<div>
                <h6 class="grid-auto-1" style="margin: .5rem">
									<div>
										{{
	                    enumService.getEnumerationText(
	                        oeSummary.summary.OEDetails.oe_enmName_OETyp,
	                        oeSummary.summary.OEDetails.oe_enmIdent_OETyp
	                    ) === 'Person' ? 'Person' : 'Organisation'
										}}
									</div>
									<div class="typo-right">
										oeID: {{oeSummary.summary.OEDetails.oeID}}
									</div>
                </h6>
                <div class="grid-1-auto" style="align-items: start;">
                  <div>
                    <ng-container *ngIf="!editMode">
								<p>
									<label>
										{{
	                    enumService.getFieldCaption('OE', 'oe_enmIdent_OETyp')
										}}
									</label>
									<span>
										{{
											enumService.getEnumerationText(
													oeSummary.summary.OEDetails.oe_enmName_OETyp,
	                        oeSummary.summary.OEDetails.oe_enmIdent_OETyp
											)
										}}
	                </span>
									<!-- Mandant -->
									<ng-container *ngIf="enumService.getEnumerationText(
		                            oeSummary.summary.OEDetails.oe_enmName_OETyp,
		                            oeSummary.summary.OEDetails.oe_enmIdent_OETyp
		                        ) === 'Person'">
										<label>
											{{
                        enumService.getFieldCaption('OE', 'oe_enmIdent_AnredeTyp')
											}}
										</label>
										<span>
											{{
                        enumService.getEnumerationText(
                            oeSummary.summary.OEDetails.oe_enmName_AnredeTyp,
                            oeSummary.summary.OEDetails.oe_enmIdent_AnredeTyp
                        )
											}}
										</span>
										<label>
											{{
	                      enumService.getFieldCaption('OE', 'oeNPraefix')
											}}
										</label>
											<span>
												{{ oeSummary.summary.OEDetails.oeNPraefix }}
										</span>
									</ng-container>
									<!-- Mandant -->
									<label>
										{{
	                    enumService.getEnumerationText(
	                        oeSummary.summary.OEDetails.oe_enmName_OETyp,
	                        oeSummary.summary.OEDetails.oe_enmIdent_OETyp
	                    ) === 'Person' ?
			                    enumService.getFieldCaption('OE', 'oeName')
			                    : enumService.getFieldCaption('Organisation', 'BEZ')
										}}
									</label>
									<span>
										{{oeSummary.summary.OEDetails.oeName}}
									</span>
									<!-- Mandant -->
									<label>
										{{
	                    enumService.getEnumerationText(
	                        oeSummary.summary.OEDetails.oe_enmName_OETyp,
	                        oeSummary.summary.OEDetails.oe_enmIdent_OETyp
	                    ) === 'Person' ?
			                    enumService.getFieldCaption('OE', 'oeEName')
			                    : enumService.getFieldCaption('Organisation', 'KBZ')
										}}
									</label>
									<span>
										{{
	                    enumService.getEnumerationText(
	                        oeSummary.summary.OEDetails.oe_enmName_OETyp,
	                        oeSummary.summary.OEDetails.oe_enmIdent_OETyp
	                    ) === 'Person' ?
			                    oeSummary.summary.OEDetails.oeEName
			                    : oeSummary.summary.OEDetails.oeNPraefix
										}}
									</span>
									<!-- Mandant -->
									<label>
										{{
	                    enumService.getFieldCaption('OE', 'oe_CrmRolle')
										}}
									</label>
									<span>
										{{
	                    oeSummary.summary.OEDetails.oe_CrmRolle ?
		                    enumService.getEnumerationText(
		                        'CrmRolle' + (
					                    enumService.getEnumerationText(
			                            oeSummary.summary.OEDetails.oe_enmName_OETyp,
			                            oeSummary.summary.OEDetails.oe_enmIdent_OETyp
			                        ) === 'Person' ? 'Person' : 'Organisation'
				                    ),
		                        oeSummary.summary.OEDetails.oe_CrmRolle
		                    ) : ''
										}}
	                </span>
								</p>
							</ng-container>
										<ng-container *ngIf="editMode">
											<app-exg-select-enumeration [caption]="enumService.getFieldCaption('OE', 'oe_enmIdent_OETyp')"
											                            [(value)]="oeSummary.summary.OEDetailsClone.oe_enmIdent_OETyp"
											                            enumerationName="OETyp"
											>
											</app-exg-select-enumeration>
											<ng-container *ngIf="enumService.getEnumerationText(
			                              oeSummary.summary.OEDetailsClone.oe_enmName_OETyp,
			                              oeSummary.summary.OEDetailsClone.oe_enmIdent_OETyp
			                          ) === 'Person'">
												<app-exg-select-enumeration [caption]="enumService.getFieldCaption('OE', 'oe_enmIdent_AnredeTyp')"
												                            [(value)]="oeSummary.summary.OEDetailsClone.oe_enmIdent_AnredeTyp"
												                            enumerationName="AnredeTyp"
												>
												</app-exg-select-enumeration>
												<exg-input [(ngModel)]="oeSummary.summary.OEDetailsClone.oeNPraefix"
												           [caption]="enumService.getFieldCaption('OE', 'oeNPraefix')">
												</exg-input>
											</ng-container>
											<exg-input [(ngModel)]="oeSummary.summary.OEDetailsClone.oeName"
											           [caption]="enumService.getEnumerationText(
			                                        oeSummary.summary.OEDetailsClone.oe_enmName_OETyp,
			                                        oeSummary.summary.OEDetailsClone.oe_enmIdent_OETyp
			                                    ) === 'Person' ?
			                                        enumService.getFieldCaption('OE', 'oeName')
			                                        : enumService.getFieldCaption('Organisation', 'BEZ')">
											</exg-input>
											<exg-input [(ngModel)]="oeSummary.summary.OEDetailsClone.oeEName"
											           [caption]="enumService.getFieldCaption('OE', 'oeEName')"
											           *ngIf="enumService.getEnumerationText(
			                              oeSummary.summary.OEDetailsClone.oe_enmName_OETyp,
			                              oeSummary.summary.OEDetailsClone.oe_enmIdent_OETyp
			                          ) === 'Person'">
											</exg-input>
											<exg-input [(ngModel)]="oeSummary.summary.OEDetailsClone.oeNPraefix"
											           [caption]="enumService.getFieldCaption('Organisation', 'KBZ')"
											           *ngIf="enumService.getEnumerationText(
			                              oeSummary.summary.OEDetailsClone.oe_enmName_OETyp,
			                              oeSummary.summary.OEDetailsClone.oe_enmIdent_OETyp
			                          ) !== 'Person'">
											</exg-input>
											<app-exg-select-enumeration [caption]="enumService.getFieldCaption('OE', 'oe_CrmRolle')"
											                            [(value)]="oeSummary.summary.OEDetailsClone.oe_CrmRolle"
											                            [enumerationName]="oeSummary.summary.OEDetailsClone.oe_enmIdent_OETyp === 2 ? 'CrmRollePerson' : 'CrmRolleOrganisation'"
											>
											</app-exg-select-enumeration>
										</ng-container>
                  </div>
			            <div style="padding: 1rem;">
			              <div (click)="uploadLogo()" style="cursor: pointer;text-align: center;">
			                <img [src]="oeSummary.summary.OEDetails.oeLogo
			                            ? (oeSummary.summary.OEDetails.oeLogo.startsWith('data:')
			                            ? oeSummary.summary.OEDetails.oeLogo
			                            : 'data:image/png;base64,' + oeSummary.summary.OEDetails.oeLogo)
			                            : 'assets/images/NoImage.png'"
			                     alt="Logo"
			                     style="max-width: 150px; max-height: 100px; object-fit: contain;">
			                <div style="font-size: 12px; color: #888; margin-top: 4px;">
			                  {{ oeSummary.summary.OEDetails.oeLogo ? getResource('action.clickToChange') : getResource('action.clickToUpload') }}                </div>
			                <input type="file"
			                       id="logo-upload"
			                       accept="image/*"
			                       (change)="onLogoSelected($event)"
			                       style="display: none;">
		                </div>
		              </div>
		            </div>
		          </div>
            </div>
	        </div>
			  </div>
			</div>
			<div class="app-pancake" *ngIf="!Data.defaultOE">
				<div class="app-pancake-child md3-card-on-surface layout-auto-1">
					<div class="grid-1-auto">
						<h6 style="margin:1rem;">
							<span>{{getResource('HeaderText.Contacts')}}</span>
						</h6>
						<i class="search-filter-action fa-regular fa-plus"
						   (click)="openModalOeContactComponent()"
						   style="margin: 0 .5rem">
						</i>
					</div>
					<!-- Contacts -->
					<div class="content">
						<ng-container *ngFor="let contact of oeSummary.summary.Contacts">
							<div style="padding: .5rem" class="list-row list-row-auto-1-auto app-cursor-pointer"
							     (dblclick)="openModalOeContactComponent(contact)">
								<div style="width: 16px;"></div>
								<div class="list-primary-text">
									{{contact.kontVal}}
								</div>
								<div>
									<span class="list-metadata typo-right">
										{{
                      enumService.getEnumerationText(
                          contact.kont_enmName_KontaktTyp,
                          contact.kont_enmIdent_KontaktTyp
                      )
										}}
									</span>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="oeSummary.summary.Contacts.length === 0">
							<div class="splash empty">
								<p style="width: inherit">Keine Kontakte vorhanden</p>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="app-pancake-child md3-card-on-surface layout-auto-1">
					<div class="grid-1-auto">
						<h6 style="margin:1rem;">
							<span>{{getResource('HeaderText.Addresses')}}</span>
						</h6>
						<i class="search-filter-action fa-regular fa-plus"
						   (click)="openModalOeAddressComponent()"
						   style="margin: 0 .5rem">
						</i>
					</div>
					<!-- Verlauf -->
					<div class="content">
						<ng-container *ngFor="let address of oeSummary.summary.Addresses">
							<div style="padding: .5rem" class="list-row list-row-auto-1-auto app-cursor-pointer"
							     (dblclick)="openModalOeAddressComponent(address)">
								<div style="width: 16px;"></div>
								<div>
									<div class="list-primary-text">
										{{address.adrStr}} {{address.adrHNum}}
									</div>
								</div>
								<div>
                  <span class="list-metadata typo-right">
										{{
                      enumService.getEnumerationText(
                          address.adr_enmName_AdresseTyp,
                          address.adr_enmIdent_AdresseTyp
                      )
	                  }}
                  </span>
								</div>
								<div style="width: 16px;"></div>
								<div>
									<div class="list-secondary-text">
										{{address.adrLkz}} - {{address.adrPlz}} {{address.adrOrt}}
									</div>
								</div>
								<div></div>
							</div>
						</ng-container>
						<ng-container *ngIf="oeSummary.summary.Addresses.length === 0">
							<div class="splash empty">
								<p style="width: inherit">Keine Adressen vorhanden</p>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
      <div class="content app-pancake" style="max-height: none; height: fit-content">
        <div class=" content app-pancake-child md3-card-on-surface layout-auto-1" style="max-height: none; height: fit-content">
          <div class="grid-1-auto">
            <h6 style="margin:1rem;">Templates</h6>
            <i class="fa-regular fa-rotate search-filter-action"
               (click)="loadAllTemplates()"
               style="margin: 0 .5rem">
            </i>
          </div>
          <div class="content">
            <ng-container *ngIf="isLoadingTemplates; else notLoadingTemplates">
              <div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div>
            </ng-container>
            <ng-template #notLoadingTemplates>
              <ng-container *ngIf="ConfigTemplateTree?.dataSource?.length">
                <cdk-tree [dataSource]="ConfigTemplateTree.dataSource"
                          [treeControl]="ConfigTemplateTree.treeControl">

                  <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: ConfigTemplateTree.hasChild"
                                        class="example-tree-node content">
                    <div class="list-row"
                         [class.app-cursor-pointer]="(node.childCount || node.children?.length) > 0"
                         (click)="toggleFolder(node, $event)">
                      <div class="grid-auto-1" style="padding:0.5rem">
                        <div class="list-avatar nobackground">
                          <ng-container *ngIf="(node.childCount || node.children?.length) > 0">
                            <i class="fa-fw fa-solid"
                               *ngIf="node.childCount > 0 || (node.children && node.children[0]?.is_directory)"
                               [class.fa-folder-open]="ConfigTemplateTree.treeControl.isExpanded(node)"
                               [class.fa-folder]="!ConfigTemplateTree.treeControl.isExpanded(node)">
                            </i>
                            <i class="fa-fw far"
                               *ngIf="!node.childCount && (!node.children || !node.children[0]?.is_directory)"
                               [class.fa-folder-open]="ConfigTemplateTree.treeControl.isExpanded(node)"
                               [class.fa-folder]="!ConfigTemplateTree.treeControl.isExpanded(node)">
                            </i>
                          </ng-container>

                          <ng-container *ngIf="!(node.childCount || node.children?.length)">
                            <i class="far fa-fw fa-folder"></i>
                          </ng-container>
                        </div>

                        <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                          <div class="list-metadata" style="margin-left:0">
<!--                            <div>{{node.childCount || node.children?.length || 0}}files </div>-->
                          </div>
                          <div style="min-width: 0"></div>
                          <div class="span-2">
                            <div class="grid-1-auto">
                              <div style="overflow: hidden">
                                <strong>{{node.rtmName || node.name}}</strong>
                                <span *ngIf="node.is_directory && getFileCount(node) > 0"> ({{getFileCount(node)}})</span>
                              </div>
                              <div class="typo-right app-space-top_1">
                                <span flow="left"
                                      style="font-size: medium"
                                      *ngIf="node.rtmIsEditable || Data.defaultOE">
                                  <i class="search-action fa-duotone fa-upload"
                                     (click)="onFileSelected(node); $event.stopPropagation()">
                                  </i>
                                </span>
                                <input type="file"
                                       [id]="'file-'+node.stream_id"
                                       (change)="uploadTemplate(node, $event)"
                                       style="display:none">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div [hidden]="!ConfigTemplateTree.treeControl.isExpanded(node)">
                      <ng-container cdkTreeNodeOutlet></ng-container>
                    </div>
                  </cdk-nested-tree-node>

                  <cdk-tree-node *cdkTreeNodeDef="let node"
                                 class="example-tree-node">
                    <div class="list-row app-document-list-row">
                      <div class="grid-auto-1">
                        <div class="list-avatar nobackground">
                          <i class="far fa-file fa-2x"
                             style="cursor: pointer"
                             (click)="showTemplatePreview(node); $event.stopPropagation()">
                          </i>
                        </div>
                        <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                          <div class="list-metadata" style="margin-left:0">
                            <div>{{node.file_type?.toUpperCase() || 'File'}}</div>
                          </div>
                          <div class="list-metadata">
                            <div class="typo-right">{{node.last_write_time | excDate: 'Globals.DateTimeFormatShort'}}</div>
                            <div class="typo-right">{{node.creation_time | excDate: 'Globals.DateTimeFormatShort'}}</div>
                          </div>
                          <div class="span-2">
                            <div class="grid-1-auto">
                              <div style="overflow: hidden">
                                <strong>{{node.rtmName}}{{node.rtmErw}}</strong>
                              </div>
                              <div class="typo-right app-space-top_1">
                                <span flow="left" style="font-size: medium">
                                  <i class="search-action fa-duotone fa-eye"
                                     (click)="showTemplatePreview(node); $event.stopPropagation()">
                                  </i>
                                </span>
          <!--                      <span flow="left" style="font-size: medium" *ngIf="node.rtmIsEditable">-->
          <!--                        <i class="search-action fa-duotone fa-pencil">-->
          <!--                        </i>-->
          <!--                      </span>-->
                                <span flow="left" style="font-size: medium" *ngIf="node.rtmIsEditable || Data.defaultOE">
                                  <i class="search-action fa-duotone fa-trash-alt"
                                     (click)="deleteTemplate(node); $event.stopPropagation()">
                                  </i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </cdk-tree-node>
                </cdk-tree>
              </ng-container>
              <ng-container *ngIf="!ConfigTemplateTree?.dataSource?.length">
                <div class="splash empty">
                  <p style="width: 100%">{{getTranslation('Es wurden keine Daten gefunden!')}}</p>
                </div>
              </ng-container>
            </ng-template>
          </div>
        </div>
      </div>
			<div class="app-pancake"
			     *ngIf="(enumService.getEnumerationText(
	              oeSummary.summary.OEDetails.oe_enmName_OETyp,
	              oeSummary.summary.OEDetails.oe_enmIdent_OETyp
              ) !== 'Person') && !Data.defaultOE"
			>
				<div class="app-pancake-child md3-card-on-surface layout-auto-1">
					<h6 style="margin:1rem;">
						<span>{{getResource('HeaderText.Persons')}}</span>
					</h6>
					<!-- Persons -->
					<div class="content">
						<ng-container *ngFor="let person of oeSummary.summary.Persons">
							<div style="padding: .5rem" class="list-row list-row-auto-1-auto"
							     (dblclick)="openOEWorkspaceTab(person.oeID)">
								<div style="width: 16px;"></div>
								<div>
									<div class="list-primary-text">
										{{person.oeName}}, {{person.oeEName}}
									</div>
								</div>
								<div>
									<i class="search-filter-action fal fa-trash-alt"
									   (click)="removeOeParentChildRelation(Data.oeID, person.oeID); $event.stopPropagation()"
									   style="margin: 0 .5rem">
									</i>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="oeSummary.summary.Persons.length === 0">
							<div class="splash empty">
								<p style="width: inherit">Keine zugehörigen Personen vorhanden</p>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="app-pancake-child md3-card-on-surface layout-auto-1">
					<div class="grid-1-auto">
						<h6 style="margin:1rem;">
							<span>{{getResource('HeaderText.Members')}}</span>
						</h6>
					</div>
					<!-- Members -->
					<div class="content">
						<ng-container *ngFor="let member of oeSummary.summary.Members">
							<div style="padding: .5rem" class="list-row list-row-auto-1-auto"
							     (dblclick)="openOEWorkspaceTab(member.oeID)">
								<div style="width: 16px;"></div>
								<div class="grid-1-auto">
									<div class="list-primary-text"
									     *ngIf="enumService.getEnumerationText(
                                member.oe_enmName_OETyp,
                                member.oe_enmIdent_OETyp
                              ) === 'Person'">
										{{member.oeName}}, {{member.oeEName}}
									</div>
									<div class="list-primary-text"
									     *ngIf="enumService.getEnumerationText(
                                member.oe_enmName_OETyp,
                                member.oe_enmIdent_OETyp
                              ) !== 'Person'">
										{{member.oeName}}
									</div>
									<div>
	                  <span class="list-metadata typo-right">
											{{
	                      member.oe_CrmRolle ?
	                          enumService.getEnumerationText(
	                              'CrmRolle' + (
	                                  enumService.getEnumerationText(
	                                      member.oe_enmName_OETyp,
	                                      member.oe_enmIdent_OETyp
	                                  ) === 'Person' ? 'Person' : 'Organisation'
	                              ),
	                              member.oe_CrmRolle
	                          ) : ''
		                  }}
	                  </span>
									</div>
								</div>
								<div>
									<i class="search-filter-action fal fa-trash-alt"
									   (click)="removeOeParentChildRelation(Data.oeID, member.oeID); $event.stopPropagation()"
									   style="margin: 0 .5rem">
									</i>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="oeSummary.summary.Members.length === 0">
							<div class="splash empty">
								<p style="width: inherit">Keine Mitglieder vorhanden</p>
							</div>
						</ng-container>
					</div>
				</div>
			</div>

			<div class="app-pancake">
				<div class="app-pancake-child md3-card-on-surface layout-auto-1"
				     *ngIf="!Data.defaultOE">
					<div class="grid-1-auto">
						<h6 style="margin:1rem;">
							<span>{{getResource('HeaderText.MembersOf')}}</span>
						</h6>
						<app-exg-dropdown>
							<ng-template #hostTemplate>
								<i class="fa-regular fa-plus search-filter-action"
								   style="margin: 0 .5rem"
								   [tooltip]="getRessource('bearbeiten')"
								   flow="left">
								</i>
							</ng-template>
							<ng-template #contentTemplate let-popup>
								<div *ngFor="let row of memberActions">
									<div class="list-row list-single-line typo-small"
									     style="cursor: pointer"
									     (click)="row.click(); popup.close()">
										{{row.caption}}
									</div>
								</div>
							</ng-template>
						</app-exg-dropdown>
					</div>
					<!-- MemberOf -->
					<div class="content">
						<ng-container *ngFor="let member of oeSummary.summary.MemberOf">
							<div style="padding: .5rem" class="list-row list-row-auto-1-auto"
							     (dblclick)="openOEWorkspaceTab(member.oeID)">
								<div style="width: 16px;"></div>
								<div class="grid-1-auto">
									<div class="list-primary-text"
									     *ngIf="enumService.getEnumerationText(
                              member.oe_enmName_OETyp,
                              member.oe_enmIdent_OETyp
                            ) === 'Person'">
										{{member.oeName}}, {{member.oeEName}}
									</div>
									<div class="list-primary-text"
									     *ngIf="enumService.getEnumerationText(
                              member.oe_enmName_OETyp,
                              member.oe_enmIdent_OETyp
                            ) !== 'Person'">
										{{member.oeName}}
									</div>
									<div>
	                  <span class="list-metadata typo-right">
											{{
	                      member.oe_CrmRolle ?
	                          enumService.getEnumerationText(
	                              'CrmRolle' + (
	                                  enumService.getEnumerationText(
	                                      member.oe_enmName_OETyp,
	                                      member.oe_enmIdent_OETyp
	                                  ) === 'Person' ? 'Person' : 'Organisation'
	                              ),
	                              member.oe_CrmRolle
	                          ) : ''
		                  }}
	                  </span>
									</div>
								</div>
								<div>
									<i class="search-filter-action fal fa-trash-alt"
									   (click)="removeOeParentChildRelation(member.oeID, Data.oeID); $event.stopPropagation()"
									   style="margin: 0 .5rem">
									</i>
								</div>
							</div>
						</ng-container>
						<ng-container *ngFor="let group of oeSummary.summary.Groups">
							<div style="padding: .5rem" class="list-row list-row-auto-1-auto">
								<div style="width: 16px;"></div>
								<div class="grid-1-auto">
									<div>
										<div class="list-primary-text">
											{{group.grpKBZ}}
										</div>
										<div class="list-secondary-text">
											<p style="margin: 0">{{group.grpBEZ}}</p>
										</div>
									</div>
									<div>
										<span class="list-metadata typo-right">
											{{getRessource('metadataGroup')}}
	                  </span>
									</div>
								</div>
								<div>
									<i class="search-filter-action fal fa-trash-alt"
									   (click)="removeGroup(group); $event.stopPropagation()"
									   style="margin: 0 .5rem">
									</i>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="(oeSummary.summary.MemberOf.length + oeSummary.summary.Groups.length) === 0">
							<div class="splash empty">
								<p style="width: inherit">Keine Mitgliedschaften vorhanden</p>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="app-pancake-child" style="margin-left: 10px; min-height: unset; max-height: unset;"
				     *ngIf="enumService.getEnumerationText(
	              oeSummary.summary.OEDetails.oe_enmName_OETyp,
	              oeSummary.summary.OEDetails.oe_enmIdent_OETyp
              ) === 'Person'">
				</div>
				<div class="app-pancake-child md3-card-on-surface layout-auto-1"
				     *ngIf="enumService.getEnumerationText(
	              oeSummary.summary.OEDetails.oe_enmName_OETyp,
	              oeSummary.summary.OEDetails.oe_enmIdent_OETyp
              ) !== 'Person'">
					<div class="grid-1-auto">
						<h6 style="margin:1rem;">
							<span>{{getResource('HeaderText.QuestionnaireConfig')}}</span>
						</h6>
						<i class="search-filter-action fa-regular fa-plus"
						   (click)="openModalOeQuestionnaireComponent()"
						   style="margin: 0 .5rem">
						</i>
					</div>
					<!-- QuestionnaireConfig -->
					<div class="content">
						<ng-container *ngFor="let config of oeSummary.summary.QuestionnaireConfig">
							<div style="padding: .5rem" class="list-row list-row-auto-1-auto"
							     (dblclick)="openQuestionnairTemplate(config)">
								<div style="width: 16px;"></div>
								<div>
									<div class="list-primary-text">
										{{config.qcfgName}}
									</div>
								</div>
								<div>
									<i class="search-filter-action fal fa-pencil"
									   (click)="openModalOeQuestionnaireComponent(config); $event.stopPropagation()"
									   style="margin: 0 .5rem">
									</i>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="oeSummary.summary.QuestionnaireConfig.length === 0">
							<div class="splash empty">
								<p style="width: inherit">Keine Berichtskonfiguration vorhanden</p>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="app-pancake-child md3-card-on-surface layout-auto-1"
				     *ngIf="enumService.getEnumerationText(
	              oeSummary.summary.OEDetails.oe_enmName_OETyp,
	              oeSummary.summary.OEDetails.oe_enmIdent_OETyp
              ) !== 'Person'">
					<div class="grid-1-auto">
						<h6 style="margin:1rem;">
							<span>{{getResource('HeaderText.CalcConfig')}}</span>
						</h6>
						<i class="search-filter-action fa-regular fa-plus"
						   (click)="openModalOeCalculationComponent()"
						   style="margin: 0 .5rem">
						</i>
					</div>
					<!-- QuestionnaireConfig -->
					<div class="content">
						<ng-container *ngFor="let config of oeSummary.summary.CalculationConfig">
							<div style="padding: .5rem" class="list-row list-row-auto-1-auto"
							     (click)="openCalculationTemplate(config)">
								<div style="width: 16px;"></div>
								<div>
									<div class="grid-1-auto">
										<div class="list-primary-text">
											{{config.ctName}}
										</div>
										<div>
		                  <span class="list-metadata typo-right">
			                  {{config.ct_aue_enmIdent_Versicherungsart ? enumService.getEnumerationText('Versicherungsart', config.ct_aue_enmIdent_Versicherungsart) : ''}}
		                  </span>
										</div>
									</div>
								</div>
								<div>
									<i class="search-filter-action fal fa-pencil"
									   (click)="openModalOeCalculationComponent(config); $event.stopPropagation()"
									   style="margin: 0 .5rem">
									</i>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="oeSummary.summary.CalculationConfig.length === 0">
							<div class="splash empty">
								<p style="width: inherit">Keine Kalkulationskonfiguration vorhanden</p>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="app-pancake-child md3-card-on-surface layout-auto-1"
				     *ngIf="enumService.getEnumerationText(
	              oeSummary.summary.OEDetails.oe_enmName_OETyp,
	              oeSummary.summary.OEDetails.oe_enmIdent_OETyp
              ) !== 'Person'">
					<div class="grid-1-auto">
						<h6 style="margin:1rem;">
							<span>{{getResource('HeaderText.FormularTemplate')}}</span>
						</h6>
						<i class="search-filter-action fa-regular fa-plus"
						   (click)="openModalOeFormularTemplateComponent()"
						   style="margin: 0 .5rem">
						</i>
					</div>
					<!-- QuestionnaireConfig -->
					<div class="content">
						<ng-container *ngFor="let config of oeSummary.summary.FormularTemplate">
							<div style="padding: .5rem" class="list-row list-row-auto-1-auto"
							     (click)="openFormularTemplate(config)">
								<div style="width: 16px;"></div>
								<div>
									<div class="grid-1-auto">
										<div class="list-primary-text">
											{{config.frmTName}}
										</div>
										<div>
		                  <span class="list-metadata typo-right">
			                  {{config.frmT_aue_enmIdent_Versicherungsart ? enumService.getEnumerationText('Versicherungsart', config.frmT_aue_enmIdent_Versicherungsart) : ''}}
		                  </span>
										</div>
									</div>
								</div>
								<div>
									<i class="search-filter-action fal fa-pencil"
									   (click)="openModalOeFormularTemplateComponent(config); $event.stopPropagation()"
									   style="margin: 0 .5rem">
									</i>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="oeSummary.summary.FormularTemplate.length === 0">
							<div class="splash empty">
								<p style="width: inherit">Keine Formular Templates vorhanden</p>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="app-pancake-child" style="margin-left: 10px; min-height: unset; max-height: unset;"
				     *ngIf="enumService.getEnumerationText(
	              oeSummary.summary.OEDetails.oe_enmName_OETyp,
	              oeSummary.summary.OEDetails.oe_enmIdent_OETyp
              ) !== 'Person'">
				</div>
			</div>
		</div>
		<!-- Side Bar -->
		<div class="md3-card-on-surface app-height-auto app-drawer" style="overflow: visible">
			<i class="disabled search-filter-action"></i>
			<ng-container *ngIf="!Data.defaultOE">
				<ng-container *ngIf="editMode">
					<i class="fal fa-save search-filter-action"
					   (click)="updateOe()"
					   [tooltip]="getGlobal('Save')"
					   [class.disabled]="!appSvc.helperObj.changed(oeSummary.summary.OEDetails, oeSummary.summary.OEDetailsClone)"
					   flow="left">
					</i>
					<i class="fal fa-xmark search-filter-action"
					   (click)="cancelUpdate()"
					   [tooltip]="getGlobal('Cancel')"
					   flow="left">
					</i>
				</ng-container>
				<ng-container *ngIf="!editMode">
					<i class="fal fa-pencil search-filter-action"
					   (click)="editMode = !editMode"
					   [tooltip]="getRessource('bearbeiten')"
					   flow="left">
					</i>
					<i class="search-filter-seperator"></i>
					<app-exg-dropdown>
						<ng-template #hostTemplate>
							<i class="fal fa-plus search-filter-action"
							   [tooltip]="getGlobal('Create')"
							   flow="left">
							</i>
						</ng-template>
						<ng-template #contentTemplate let-popup>
							<div *ngFor="let row of oeActions">
								<div class="list-row list-single-line typo-small"
								     style="cursor: pointer"
								     (click)="row.click(); popup.close()">
									{{row.caption}}
								</div>
							</div>
						</ng-template>
					</app-exg-dropdown>
					<ng-container *ngIf="excSecurity.isFeatured('DEVELOPMENT')">
						<i class="search-filter-seperator"></i>
						<i class="search-filter-action fa-light fa-list-timeline"
						   [tooltip]="getRessource('history')"
						   flow="left">
						</i>
					</ng-container>
				</ng-container>
			</ng-container>
		</div>
	</div>
</div>
<!-- Loading -->
<ng-container *ngIf="oeSummary.isLoading">
	<div class="content md3-surface">
		<div class="splash loading">
		</div>
	</div>
</ng-container>
